import * as Yup from 'yup';
import {
  street1Validation,
  street2Validation,
  cityValidaton,
  stateValidation,
  zipValidation,
  countryValidation,
} from 'components/FormFields/PII';
import homeAddressFormModel from './formModel';

const {
  groupId,
  formFields: { street1, street2, city, state, zip, country },
} = homeAddressFormModel;

const homeAddressFormValidationSchema = Yup.object().shape({
  [groupId]: Yup.object()
    .shape({
      [street1.name]: street1Validation,
      [street2.name]: street2Validation,
      [city.name]: cityValidaton,
      [state.name]: stateValidation,
      [zip.name]: zipValidation,
      [country.name]: countryValidation,
    })
    .required(),
});

export default homeAddressFormValidationSchema;
